import React, { useContext } from "react"
import { DataGrid } from "@material-ui/data-grid";
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import TabelaTheme from "./Tabela.styles";
import { changeImplantationStatus } from "../../services/apiCliente";
import { UserContext } from "../../screen/dashboard";
import { styled } from '@material-ui/styles';

const columns = [
    {
        field: "id",
        headerName: "Cliente",
        minWidth: 267,
    },
    {
        field: "status",
        headerName: "Status",
        minWidth: 267,
    },
    {
        field: "data",
        headerName: "Data da Execução",
        type: "dateTime",
        minWidth: 267,
    },

    {
        field: "motivoFalha",
        headerName: "Motivo da Falha",
        minWidth: 267,
    },
];

const columnsCardBackup = [
    {
        field: "id",
        headerName: "Cliente",
        minWidth: 267,
    },
    {
        field: "data",
        headerName: "Data da última execução",
        type: "dateTime",
        minWidth: 267,
    }
];

const CustomButton = styled(Button)(({theme}) => ({
    marginRight: 10,
}));

const RenderActionButtons = (params) => {
    const user = useContext(UserContext);
    return(
        <>
            <CustomButton sx={{mr: 10}} color="primary" variant="contained" onClick={() => changeStatus(params.row, user, 2)}>Resolvido</CustomButton>
            <Button color="primary" variant="outlined" onClick={() => changeStatus(params.row, user, 3)}>Ignorar</Button>
        </>
    );
};

const changeStatus = (param, user, status) => {
    const dto = {
        id: param.implantationID,
        crm: param.id,
        employee: user,
        status: status
    }
    changeImplantationStatus(dto);
}

const columnsWithButton = [
    {
        field: "id",
        headerName: "Cliente",
        width: 110,
    },
    {
        field: 'implantationID',
        headerName: 'Id',
        width: 100,
        hide: true
    },
    {
        field: "status",
        headerName: "Status",
        width: 100,
    },
    {
        field: "createdAt",
        headerName: "Data de criação",
        type: "dateTime",
        width: 200,
    },

    {
        field: "machine",
        headerName: "Maquina",
        width: 250,
    },
    {
        field: "dbname",
        headerName: "Nome da Base",
        width: 250,
    },
    {
        field: "Actions",
        headerName: "Ações",
        width: 250,
        renderCell: RenderActionButtons
    }
];

const BarraPesquisa = (props) => {
    const classes = TabelaTheme();

    return (
        <div className={classes.root}>
            <TextField
                variant="standard"
                value={props.value}
                onChange={props.onChange}
                placeholder="Pesquisar"
                className={classes.textField}
                InputProps={{
                    startAdornment: <SearchIcon fontSize="small" />,
                    endAdornment: (
                        <IconButton
                            title="Limpar"
                            aria-label="Limpar"
                            size="small"
                            style={{ visibility: props.value ? 'visible' : 'hidden' }}
                            onClick={props.clearSearch}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    ),
                }}
            />
        </div>
    );
}

BarraPesquisa.propTypes = {
    clearSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

const escapeRegExp = (value) => {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

const Tabela = (props) => {

    const [pesquisaTexto, setPesquisaTexto] = React.useState('');
    const [rows, setRows] = React.useState([]);
    const [allRows, setAllRows] = React.useState([])

    const tabelaAtual = props.tabelaAtual;

    const requestSearch = (searchValue) => {
        setPesquisaTexto(searchValue);
        const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
        const filteredRows = allRows.filter((row) => {
            return Object.keys(row).some((field) => {
                return searchRegex.test(row[field].toString());
            });
        });
        setRows(filteredRows);
    };

    const implantationStatus = {
        '1': 'Pendente',
        '2': 'Resolvido',
        '3': 'Ignorado'
      }
    
    const getLinhas = () => {
        return tabelaAtual.map((item) => {
            if (item.status) {
                return {
                    implantationID: item.id,
                    id: item.crm,
                    status: implantationStatus[item.status],
                    createdAt: new Date(item.created_at),
                    dbname: item.databases
                    ? item.databases.join(', ')
                    : "Sem registro",
                    machine: item.machine ? item.machine : "Sem Registro",
                };
              }
            let motivoFalha = !item.errorDetail ? "Sem motivo" : item.codeError.toUpperCase();
            let status = (item.statusBackup && item.statusUpload) ? "Sucesso" : "Falha";
            if (item.lastBackupSucess === null && item.lastUploadSucess === null) {
                status = "N/A";
                motivoFalha = "Cliente Novo";
            }
            return {
                id: item.client.crm,
                data: item.lastBackupSucess ? new Date(item.lastBackupSucess).toLocaleString() : new Date(item.comunicacao),
                dataBackupSucesso: item.lastBackupSucess ? new Date(item.lastBackupSucess).toLocaleString() : "Sem registro",
                motivoFalha,
                status,
            };
        });
    }

    const defineColumns = (props) => {
        if(props.allowActions) return columnsWithButton;
        if(/(Clientes sem backup)/.test(props.cardTitle)) return columnsCardBackup;
        return columns;
    }

    React.useEffect(() => {
        setRows(getLinhas())
        setAllRows(getLinhas())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tabelaAtual])

    return (
        <DataGrid
            rows={rows}
            columns={defineColumns(props)}
            pageSize={25}
            rowsPerPageOptions={[25]}
            disableColumnMenu
            disableColumnSelector
            disableMultipleSelection
            disableSelectionOnClick
            components={{ Toolbar: BarraPesquisa }}
            componentsProps={{
                toolbar: {
                    value: pesquisaTexto,
                    onChange: (event) => requestSearch(event.target.value),
                    clearSearch: () => requestSearch(''),
                    
                },
            }}
        />
    )
}

export default Tabela;
